import * as Yup from "yup";

export const userSchema = Yup.object().shape({
  name: Yup.string().required("Name is required."),
  email: Yup.string()
    .email("Invalid email format.")
    .required("Email is required."),
  address: Yup.string().required("Address is required."),
});
